import React, { useEffect, useRef, useState } from 'react';

const CustomMultiSelect = ({
  ref,
  id,
  className,
  placeholder = '',
  options,
  row,
  isMulti,
  field,
  selectedVal,
  setselectedVal,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const innerInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'visible';
    }
  }, [isOpen]);
  useEffect(() => {
    document.addEventListener('click', toggle);
    return () => document.removeEventListener('click', toggle);
  }, []);
  useEffect(() => {
    field.onChange(selectedVal);
  }, [selectedVal]);

  const filter = options => {
    if (options) {
      return options?.filter(option => option?.label);
    }
    return options;
  };
  function toggle(e) {
    setIsOpen(e && (e.target === inputRef.current || e.target === innerInputRef.current));
  }

  const getDisplayValue = () => {
    return selectedVal.length > 0 ? `(${selectedVal.length}) ${selectedVal.map(({ label }) => label)}` : '';
  };

  const handleChange = value => {
    selectedVal.some(selectedVal => selectedVal.value === value.value)
      ? setselectedVal(selectedVal.filter(selectedVal => selectedVal.value !== value.value))
      : setselectedVal([...selectedVal, value]);
  };
  const selectOption = option => {
    handleChange(option);
  };

  return (
    <div className="select_region ">
      <input
        ref={inputRef}
        type="text"
        value={getDisplayValue()}
        name={id}
        className={`form_control cursor_pointer  ${
          (isOpen || getDisplayValue()) && 'blue_border '
        } ${isOpen ? 'active' : ''}`}
        onClick={toggle}
        placeholder={placeholder}
        autoComplete="off"
        readOnly
      />
      <div className="addition_info_select_svg">
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
          <path
            d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
            fill="#aeaeae"></path>
        </svg>
      </div>
      {isOpen && (
        <div
          style={{ display: 'block' }}
          className={`options_status ${className} ${isOpen ? 'open' : ''}`}
          ref={containerRef}>
          {filter(options)?.map((option, index) => {
            return (
              <div
                className={`all_location d_flex ${
                  selectedVal.some(({ value }) => value === option.value) ? 'active' : ''
                }`}
                onClick={e => {
                  e.stopPropagation();
                  selectOption(option);
                }}>
                <div className="i_main_options">
                  <div className={`list_status`} key={`${id}-${index}`}>
                    <div className="check_box">
                      <input
                        className="custom_check"
                        type="checkbox"
                        checked={selectedVal.some(({ value }) => value === option.value)}
                      />
                      <span className="checkmark" />
                    </div>
                    <div className="select_tab">
                      <span
                        className={`region_tab word_break_word ${
                          selectedVal.some(({ value }) => value === option.value) && 'selected'
                        } ${option.label === 'Active' && 'active '} ${
                          option.label === 'Pending' && 'pending '
                        } ${option.label === 'In Progress' && 'inprogress '} ${
                          option.label === 'Invited' && 'invited'
                        } ${option.label === 'Draft' && 'invited'} status_tab `}>
                        {option.label}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomMultiSelect;
